// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.psg-exdetail-sheet.player-session-results__sheet {
  max-width: 640px;
}

.psg-exdetail-body.player-session-results__body {
  padding: 0 !important;
  background: var(--bg-color, #f5f8fa) !important;
  color: var(--text-color, #1a2b3c);
}

.dark-mode .psg-exdetail-body.player-session-results__body,
html[data-theme="dark"] .psg-exdetail-body.player-session-results__body {
  background: var(--bg-color, #0f172a) !important;
  color: var(--text-color, #f9fafb);
}

.psg-exdetail-page.exdetail-page {
  max-width: none;
  margin: 0;
  padding: 12px 16px 16px;
}

.psg-exdetail-loading,
.psg-exdetail-empty {
  margin: 0;
  padding: 24px 16px;
  text-align: center;
  color: var(--text-secondary, #64748b);
  font-size: 14px;
  font-weight: 600;
}

.psg-exdetail-seqs {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.psg-exdetail-seqs li {
  margin: 0;
}

.psg-exdetail-seq-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 44px;
  padding: 8px 12px;
  border-radius: 10px;
  background: color-mix(in srgb, var(--text-color, #1a2b3c) 4%, var(--surface-color, #fff));
  border: 1px solid var(--border-color, #e8eef3);
  font: inherit;
  font-size: 13px;
  font-weight: 650;
  color: var(--text-color, #37474f);
  text-align: left;
  cursor: pointer;
}

.psg-exdetail-seq-btn:disabled {
  cursor: default;
}

.psg-exdetail-seq-btn:not(:disabled):hover {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color, #fff));
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 28%, var(--border-color, #e8eef3));
}

.psg-exdetail-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 16px max(12px, env(safe-area-inset-bottom, 0px));
  border-top: 1px solid var(--border-color, #e2e8f0);
  background: var(--surface-color, #fff);
  flex-shrink: 0;
}

.psg-exdetail-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  padding: 10px 14px;
  border-radius: 12px;
  font: inherit;
  font-size: 14px;
  font-weight: 750;
  cursor: pointer;
  flex: 1 1 auto;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color, #fff));
  color: var(--brand-primary, #0877bc);
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 32%, var(--border-color, #e2e8f0));
}

.psg-exdetail-btn--ghost {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color, #fff));
  color: var(--brand-primary, #0877bc);
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 32%, var(--border-color, #e2e8f0));
}

.dark-mode .psg-exdetail-btn,
.dark-mode .psg-exdetail-btn--ghost,
html[data-theme="dark"] .psg-exdetail-btn,
html[data-theme="dark"] .psg-exdetail-btn--ghost {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color, #111827));
  color: color-mix(in srgb, var(--brand-primary, #0877bc) 55%, #fff);
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 40%, transparent);
}

.psg-exdetail-btn--primary {
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877bc),
    var(--brand-primary-dark, #065a8f)
  );
  color: #fff;
  border: none;
}

.dark-mode .psg-exdetail-btn--primary,
html[data-theme="dark"] .psg-exdetail-btn--primary {
  color: #fff;
}

.psg-exdetail-btn--danger {
  flex: 0 0 44px;
  min-width: 44px;
  padding: 10px;
  background: color-mix(in srgb, #c62828 12%, var(--bg-color, #fff));
  color: #c62828;
}

@media (max-width: 599px) {
  .psg-exdetail-sheet.player-session-results__sheet {
    max-width: none;
  }

  .psg-exdetail-page.exdetail-page {
    padding: 8px 8px 12px;
  }

  .psg-exdetail-actions {
    flex-wrap: wrap;
    gap: 8px;
  }

  .psg-exdetail-btn {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 8px);
    min-width: 0;
  }

  .psg-exdetail-btn--danger {
    flex: 0 0 44px;
  }

  .psg-exdetail-btn--primary {
    flex: 1 1 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/planning/PlanningExerciseDetailsDialog.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;;EAEE,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yFAAyF;EACzF,8CAA8C;EAC9C,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6FAA6F;EAC7F,iGAAiG;AACnG;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,8DAA8D;EAC9D,kDAAkD;EAClD,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,6FAA6F;EAC7F,oCAAoC;EACpC,qGAAqG;AACvG;;AAEA;EACE,6FAA6F;EAC7F,oCAAoC;EACpC,qGAAqG;AACvG;;AAEA;;;;EAIE,gGAAgG;EAChG,kEAAkE;EAClE,gFAAgF;AAClF;;AAEA;EACE;;;;GAIC;EACD,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,kEAAkE;EAClE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".psg-exdetail-sheet.player-session-results__sheet {\n  max-width: 640px;\n}\n\n.psg-exdetail-body.player-session-results__body {\n  padding: 0 !important;\n  background: var(--bg-color, #f5f8fa) !important;\n  color: var(--text-color, #1a2b3c);\n}\n\n.dark-mode .psg-exdetail-body.player-session-results__body,\nhtml[data-theme=\"dark\"] .psg-exdetail-body.player-session-results__body {\n  background: var(--bg-color, #0f172a) !important;\n  color: var(--text-color, #f9fafb);\n}\n\n.psg-exdetail-page.exdetail-page {\n  max-width: none;\n  margin: 0;\n  padding: 12px 16px 16px;\n}\n\n.psg-exdetail-loading,\n.psg-exdetail-empty {\n  margin: 0;\n  padding: 24px 16px;\n  text-align: center;\n  color: var(--text-secondary, #64748b);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.psg-exdetail-seqs {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.psg-exdetail-seqs li {\n  margin: 0;\n}\n\n.psg-exdetail-seq-btn {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  min-height: 44px;\n  padding: 8px 12px;\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--text-color, #1a2b3c) 4%, var(--surface-color, #fff));\n  border: 1px solid var(--border-color, #e8eef3);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 650;\n  color: var(--text-color, #37474f);\n  text-align: left;\n  cursor: pointer;\n}\n\n.psg-exdetail-seq-btn:disabled {\n  cursor: default;\n}\n\n.psg-exdetail-seq-btn:not(:disabled):hover {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color, #fff));\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 28%, var(--border-color, #e8eef3));\n}\n\n.psg-exdetail-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 12px 16px max(12px, env(safe-area-inset-bottom, 0px));\n  border-top: 1px solid var(--border-color, #e2e8f0);\n  background: var(--surface-color, #fff);\n  flex-shrink: 0;\n}\n\n.psg-exdetail-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 44px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 750;\n  cursor: pointer;\n  flex: 1 1 auto;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color, #fff));\n  color: var(--brand-primary, #0877bc);\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 32%, var(--border-color, #e2e8f0));\n}\n\n.psg-exdetail-btn--ghost {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color, #fff));\n  color: var(--brand-primary, #0877bc);\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 32%, var(--border-color, #e2e8f0));\n}\n\n.dark-mode .psg-exdetail-btn,\n.dark-mode .psg-exdetail-btn--ghost,\nhtml[data-theme=\"dark\"] .psg-exdetail-btn,\nhtml[data-theme=\"dark\"] .psg-exdetail-btn--ghost {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color, #111827));\n  color: color-mix(in srgb, var(--brand-primary, #0877bc) 55%, #fff);\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 40%, transparent);\n}\n\n.psg-exdetail-btn--primary {\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877bc),\n    var(--brand-primary-dark, #065a8f)\n  );\n  color: #fff;\n  border: none;\n}\n\n.dark-mode .psg-exdetail-btn--primary,\nhtml[data-theme=\"dark\"] .psg-exdetail-btn--primary {\n  color: #fff;\n}\n\n.psg-exdetail-btn--danger {\n  flex: 0 0 44px;\n  min-width: 44px;\n  padding: 10px;\n  background: color-mix(in srgb, #c62828 12%, var(--bg-color, #fff));\n  color: #c62828;\n}\n\n@media (max-width: 599px) {\n  .psg-exdetail-sheet.player-session-results__sheet {\n    max-width: none;\n  }\n\n  .psg-exdetail-page.exdetail-page {\n    padding: 8px 8px 12px;\n  }\n\n  .psg-exdetail-actions {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .psg-exdetail-btn {\n    flex: 1 1 calc(50% - 8px);\n    min-width: 0;\n  }\n\n  .psg-exdetail-btn--danger {\n    flex: 0 0 44px;\n  }\n\n  .psg-exdetail-btn--primary {\n    flex: 1 1 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
